import { DataRegistry } from './DataRegistry';

export class GoodsManager {
  static readonly instance = new GoodsManager();

  valueOfStockpile(storage: Record<string, number>) {
    const registry = DataRegistry.instance;
    return Object.entries(storage).reduce((sum, [goodId, amount]) => sum + (registry.goods[goodId]?.basePrice ?? 1) * amount, 0);
  }

  goodsByCategory(category: string) {
    return Object.values(DataRegistry.instance.goods).filter((good) => good.category === category);
  }
}
